import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-platform-modal',
  templateUrl: './add-platform-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-platform-modal.component.scss']
})

export class AddPlatformModalComponent {
  public platformForm: FormGroup
  public isLoading: boolean = false
  public isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddPlatformModalComponent>,
    @Inject(MAT_DIALOG_DATA) public fieldId: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderService: WellHeaderInfoService
  ){}

  ngOnInit(){
    this.platformForm = this.initializeForm()

    this.platformForm.get('platformShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.platformForm.get('platformShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      fieldId: this.fieldId,
      platformShortName: ['', [Validators.required, noWhitespaceValidator()]],
      platformLongName: ['', [Validators.required, noWhitespaceValidator()]],
      platformStatus: '',
      remark: '',
    })
  }

  createPlatform(){
    this.wellHeaderService.createPlatform(this.platformForm.value).subscribe(
      {
        next: (res) => {
          if(res.isSuccess){
            this.isSuccess = true
            this.closeDialog()
          }

          this.isLoading = false
        },
        error: (err) => this.isLoading = false
      }
    )
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  
  get platformShortName() {
    return this.platformForm.get('platformShortName');
  }

  get platformLongName() {
    return this.platformForm.get('platformLongName');
  }
}
